module.exports = __webpack_public_path__ + "static/media/icons-ic-callback-missed.56c93549.svg";